/**
 * The text a version is shown and diffed as — `JSON.stringify(value, null, 2)`,
 * the same format the raw editor opens a template in, so a line in the diff is a
 * line the admin will find in the editor.
 *
 * Keys are NOT sorted. Both `module_setting.value` and the history's `value` are
 * `jsonb`, which stores object keys in one canonical order, so two versions can
 * never differ by key order alone — sorting would only make the diff disagree
 * with the editor about where things are.
 */
export var historyJson = function (value) { var _a; return (_a = JSON.stringify(value, null, 2)) !== null && _a !== void 0 ? _a : 'null'; };
var canonical = function (value) {
    if (Array.isArray(value))
        return value.map(canonical);
    if (value !== null && typeof value === 'object') {
        return Object.keys(value)
            .sort()
            .reduce(function (acc, k) {
            acc[k] = canonical(value[k]);
            return acc;
        }, {});
    }
    return value;
};
/**
 * Whether two versions carry the same template. Independent of key order on
 * purpose, unlike {@link historyJson}: this answers "would restoring change
 * anything", and that must not hinge on a storage detail holding.
 */
export var sameContent = function (a, b) {
    return JSON.stringify(canonical(a)) === JSON.stringify(canonical(b));
};
/**
 * The version a row's change is measured against: the next OLDER row (the list
 * is newest first, and each row holds the value after its change). The last
 * loaded row has one on the next page whenever there is a next page — reporting
 * "no predecessor" there would turn an ordinary edit into a fake "everything
 * added".
 */
export var predecessorOf = function (entries, index, hasMore) {
    if (index + 1 < entries.length)
        return { kind: 'found', entry: entries[index + 1] };
    return hasMore ? { kind: 'pending' } : { kind: 'none' };
};
